
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/play/[state]/[city]",
      function () {
        return require("private-next-pages/play/[state]/[city]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/play/[state]/[city]"])
      });
    }
  